package com.essntl.features.service.ui.components.richtext

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.focusProperties
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.theme.esColorScheme

@Composable
fun RichEditorPanelIconItem(
    onClick: () -> Unit,
    res: String,
    selected: Boolean = false,
    enabled: Boolean = false,
    modifier: Modifier = Modifier,
) {
    Box(
        contentAlignment = Alignment.Center,
        modifier =
            modifier
                .focusProperties { canFocus = false }
                .size(28.dp)
                .clip(RoundedCornerShape(8.dp))
                .background(
                    with(MaterialTheme.esColorScheme) {
                        if (selected) borderPrimary else bgSecondary
                    },
                )
                .pointerHoverIcon(PointerIcon.Hand)
                .clickable(
                    onClick = onClick,
                    enabled = enabled,
                ),
    ) {
        EsLargeIcon(
            res = res,
        )
    }
}
